import React from "react";
import "../../styles.css";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@mui/styles";
import dayjs from "dayjs";
import "dayjs/locale/en";

const useStyles = makeStyles({
  datePickerRoot: {
    "& .MuiOutlinedInput-root": {
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
  },
  toText: {
    margin: "0 8px", // Add margin for spacing
    alignSelf: "center", // Align vertically in the center if needed
    color: "#929497",
  },
});

export default function DateRangeFilters({
  handleDateChange,
  value,
  type,
  _moduleTab,
}) {
  const classes = useStyles();

  const handleChange = (date, index) => {
    //let tempDate = ["rr", "CP", "DIP", "SLP", "DETENTION"].includes(type) ? date.format("YYYY-MM-DD") : date
    let tempDate = date.format("YYYY-MM-DD");
    if (index === 0) {
      handleDateChange([tempDate, value[1]]);
    } else if (index === 1) {
      handleDateChange([value[0], tempDate]);
    }
  };
  const todaysDate = new Date().toISOString().slice(0, 10);

  const today = new Date();
  today.setMonth(today.getMonth() + 18);

  const eighteenMonthsLater = today.toISOString().slice(0, 10);
  const dateFormat = "DD MMM YYYY";

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      dateFormats={{ normalDate: dateFormat }}
    >
      <div
        className="custom-date-range-picker"
        style={{ display: "flex", alignItems: "center" }}
      >
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            value={dayjs(value[0])}
            onChange={(date) => handleChange(date, 0)}
            classes={{ root: classes.datePickerRoot }}
            slotProps={{
              textField: { size: "small", style: { width: "150px" } },
            }}
            format={dateFormat}
            minDate={type === "FGS" ? dayjs(todaysDate) : dayjs("2020-01-01")}
            maxDate={type === "FGS" ? dayjs(eighteenMonthsLater) : null}
          />
          <span className={classes.toText}>To</span>
          <DatePicker
            value={value[1] ? dayjs(value[1]) : null} // Ensure it's a valid Dayjs object or null
            minDate={value[0] ? dayjs(value[0]) : null}
            maxDate={
              type === "ff" && value[0]
                ? dayjs(value[0]).add(10, "week")
                : type === "FGS"
                  ? dayjs(eighteenMonthsLater)
                  : null
            } // Restrict to 8 weeks only if type is 'NPS'
            disabled={!value[0]}
            onChange={(date) => handleChange(date, 1)}
            classes={{ root: classes.datePickerRoot }}
            slotProps={{
              textField: { size: "small", style: { width: "150px" } },
            }}
            format={dateFormat}
          />
        </DemoContainer>
      </div>
    </LocalizationProvider>
  );
}
